import { API_ROUTES } from "@/constant";
import PledgeAPI from "@/services/Pledge/PledgeConfig";
import {
  ApiMessageResponseInterface,
  PledgeListResponseInterface,
  PromotionHistoryResponse,
  TransactionListResponseInterface,
} from "@/types/pledgeService";

export const getPledgeList = async (params?: any): Promise<PledgeListResponseInterface> => {
  const response = await PledgeAPI.get(API_ROUTES.PLEDGE, { params });
  return response.data;
};

export const getTransactionsByUser = async (
  params?: any,
): Promise<TransactionListResponseInterface> => {
  const response = await PledgeAPI.get(API_ROUTES.PLEDGE_TRANSACTIONS, { params });
  return response.data;
};

export const getPledgeTicketPreview = async (pledgeId?: any, params?: any): Promise<string> => {
  const response = await PledgeAPI.get(API_ROUTES.PLEDGE_TICKET_PREVIEW(pledgeId), {
    params,
    responseType: "blob",
  });
  return response.data;
};

export const getBulkTicketPreview = async (pledgeIds: string): Promise<string> => {
  const response = await PledgeAPI.get(API_ROUTES.PLEDGE_BULK_TICKET_PREVIEW, {
    params: { pledgeIds: pledgeIds },
    responseType: "blob",
  });
  return response.data;
};
export const getBulkTicketPreviewV1 = async (
  payload: { pledge_id: number; amount: number }[],
): Promise<Blob> => {
  const response = await PledgeAPI.post(API_ROUTES.PLEDGE_BULK_TICKET_PREVIEW_V1, payload, {
    responseType: "blob",
  });

  return response.data;
};
export const getPromotionsByIds = async (payload: {
  pledge_ids: number[];
}): Promise<PromotionHistoryResponse> => {
  const response = await PledgeAPI.post<any>(API_ROUTES.PLEDGES_PROMOTIONS_BY_IDS, payload);
  return response.data;
};
export const provideCustomerConsent = async (payload?: any): Promise<string> => {
  const response = await PledgeAPI.post(API_ROUTES.PROVIDE_CUSTOMER_CONSENT, payload);
  return response.data;
};

export const submitERenewal = async (payload?: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.E_RENEWAL, payload);
  return response.data;
};

export const getPledgeConsentDetails = async (paringinID: string, params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.PLEDGE_CONSENT_DETAILS + paringinID, { params });
  return response.data;
};

export const fetchPawnTicketPreview = async (id: number): Promise<Blob> => {
  const response = await PledgeAPI.get(API_ROUTES.PAWN_TICKET_PREVIEW.replace(":id", String(id)), {
    responseType: "blob",
    headers: {
      Accept: "application/pdf",
    },
  });

  return response.data;
};

export const updatePledgeConsent = async (id: string, payload: any): Promise<any> => {
  const response = await PledgeAPI.put(API_ROUTES.UPDATE_PLEDGE_CONSENT + id, payload);
  return response.data;
};

export const updatePledgeConsentMetadata = async (id: string, payload: any): Promise<any> => {
  const response = await PledgeAPI.put(API_ROUTES.UPDATE_PLEDGE_CONSENT_METADATA + id, payload);
  return response.data;
};

export const getPledgeConsentStatus = async (params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.PLEDGE_CONSENT_STATUS, { params });
  return response.data;
};

export const getApplicableVouchers = async (params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.APPLICABLE_VOUCHERS, { params });
  return response.data;
};

export const getPledgeById = async (id?: number): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.GET_PLEDGE_ID + `/${id}`);
  return response.data;
};

export const getCddList = async (params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.GET_CDD_LIST, { params });
  return response.data;
};

export const createBulkCddForm = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.CDD_BULK_CREATE, payload);
  return response.data;
};

export const mpgsSession = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.MPGS_SESSION, payload);
  return response.data;
};
export const generateRenewPaynowQR = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.GENERATE_RENEW_PAYNOW_STATUS, payload);
  return response.data;
};

export const getRenewPaymentStatus = async (params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.RENEW_PAYMENT_STATUS, { params });
  return response.data;
};

export const initiatePaynetApi = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.INITIATE_PAYNET_PAYMENT, payload);
  return response.data;
};

export const getPaymentStatus = async (params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.GET_PAYMENT_STATUS, { params });
  return response.data;
};

export const erenewCreateNewPledge = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.ERENEW_CREATE_PLEDGE, payload);
  return response.data;
};

export const createMYPledge = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.MY_CREATE_PLEDGE, payload);
  return response.data;
};

export const createPledgesIdFromConsulate = async (
  id: string,
): Promise<{ pledge_renewal_ids: number[] }> => {
  const response = await PledgeAPI.get(`${API_ROUTES.GET_IDS_FROM_CONSULATE}/${id}`);
  return response.data;
};

export const getPaymentAmount = async (params?: any): Promise<any> => {
  const response = await PledgeAPI.get(API_ROUTES.GET_PAYMENT_AMOUNT, { params });
  return response.data;
};

export const createQRPayment = async (payload: any): Promise<any> => {
  const response = await PledgeAPI.post(API_ROUTES.QR_PAYMENT_PLEDGE, payload);
  return response.data;
};

export const getTicketPreviewHTML = async (id: number): Promise<any> => {
  const response = await PledgeAPI.get(
    API_ROUTES.PAWN_TICKET_PREVIEW_HTML.replace(":id", String(id)),
  );
  return response.data;
};
